import { CACHE_FRESHNESS_BANNER_THRESHOLD_DAYS } from "@/lib/constants/industry";

interface Props {
  cacheGeneratedAt: string; // ISO
  subtitle?: string;         // e.g. "Semiconductors (India)"
  isRefreshing?: boolean;    // true when a running SyncLog covers this row
}

export function IndustryFreshnessBanner({ cacheGeneratedAt, subtitle, isRefreshing }: Props) {
  const days = Math.floor((Date.now() - new Date(cacheGeneratedAt).getTime()) / 86_400_000);
  const showAge = days >= CACHE_FRESHNESS_BANNER_THRESHOLD_DAYS;
  const ageLabel = days === 0 ? "today" : days === 1 ? "1 day ago" : `${days} days ago`;

  if (!showAge && !subtitle && !isRefreshing) return null;

  return (
    <div className="flex items-center gap-2 text-xs text-slate-400">
      {showAge && <span>Industry view updated {ageLabel}</span>}
      {subtitle && <span>· {subtitle}</span>}
      {isRefreshing && (
        <span className="inline-flex items-center gap-1 rounded-full border border-amber-500/30 bg-amber-500/10 px-2 py-0.5 text-amber-400">
          <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-amber-400" />
          Refreshing
        </span>
      )}
    </div>
  );
}
